import { useState, useEffect } from 'react';
import NoticeApi from '../../api/NoticeApi';
import { useParams, Link } from 'react-router-dom';

const NoticeDetail = () => {
    const { id } = useParams();
    const [notice, setNotice] = useState({});

    useEffect(() => {
        NoticeApi.getNoticeDetail(id).then(rslt => {
            console.log(rslt.data)
            setNotice(rslt.data);
        });
    }, []);

    return (
        <div className="content">
            <h2>{notice.title}</h2>
            <div style={{ marginTop: '20px' }}>
                <div dangerouslySetInnerHTML={{ __html: notice.contents }}></div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <Link to='/notice'>목록</Link>
            </div>
        </div>
    )
}

export default NoticeDetail;